// Shared registry of column accessor keys whose filter inputs are
// free-text and therefore need a debounce (QUERY_DELAY) before
// firing a request. The legacy table renderer mutates this list at
// runtime via `registerTextFilter` for any filterable column with no
// explicit filter type (or PRICE), so consumers always observe the
// same array reference.
export const TEXT_FILTERS = [
  'customIdentifier',
  'accountCustomIdentifier',
  'address',
  'firstName',
  'lastName',
  'mrnNumber',
  'patientFirstName',
  'patientLastName',
  'patientMrnNumber',
  'viewedBy',
  'acknowledgedBy',
  'failureReason',
  'providerAssignment',
  'totalAmount',
  'totalCPTs',
  'cptCount',
  'cptPaid',
  'price',
  'paid',
  'icd',
];

export const registerTextFilter = accessorKey => {
  if (accessorKey && !TEXT_FILTERS.includes(accessorKey)) {
    TEXT_FILTERS.push(accessorKey);
  }
};
